import { Button } from "@mui/material";

import { Link } from "react-router-dom";

import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";



export default function KeyAvaileble({ limit }) {

  const count = limit ?? 0;

  const isLow = count < 5;



  return (

    <div className="app-keys">

      <div className="app-keys__info">

        <VpnKeyOutlinedIcon className="app-keys__icon" fontSize="small" />

        <span className="app-keys__label">Доступные ключи</span>

        <span

          className={`app-keys__count ${

            isLow ? "app-keys__count--low" : "app-keys__count--ok"

          }`}

        >

          {count}

        </span>

      </div>

      <Link to="/main/price" style={{ textDecoration: "none" }}>

        <Button

          variant="contained"

          size="small"

          className="app-btn app-btn--primary app-btn--compact"

        >

          Получить ключи

        </Button>

      </Link>

    </div>

  );

}

